var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("new-edit-page", {
    staticStyle: { width: "100%" },
    attrs: {
      "is-loading": _vm.loading,
      "page-title": _vm.pageTitle,
      "submit-button-label": _vm.submitButtonLabel,
      "submit-button-disabled": _vm.submitButtonDisabled,
      "one-section-only": "",
      "toggle-field-button": _vm.actionType === "edit",
      "toggle-button-label": _vm.customField.disable
        ? _vm.$t("Enable")
        : _vm.$t("Disable")
    },
    on: { submit: _vm.saveObject, toggleField: _vm.toggleField },
    scopedSlots: _vm._u([
      {
        key: "wholeSection",
        fn: function() {
          return [
            _c("custom-field-fields", {
              attrs: { customField: _vm.customField }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e8ab556", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e8ab556","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/CustomFields/CustomFieldsCreateEdit.vue
// module id = null
// module chunks = 